import { html } from 'lit-element';

import { SimpleLitElement } from '@elab/components';
import { priceFormatterForceNegative } from '@elab/core/utils/PriceUtils';
import { selectors as paymentSelectors } from '@elab/core/store/payment';
import { selectors as orderSelectors } from '@elab/core/store/order';
import connect from '@elab/core/store/connect';

/**
 * Component is used to show information related to payment information
 * currencyPlacement: ['before', 'after']
 */
export class PaymentPriceInformation extends SimpleLitElement {
    static get properties() {
        return {
            currencyPlacement: { type: String, attribute: 'currency-placement' },
            selectedMethod: { type: Object },
            getInfoFrom: { type: String, attribute: 'get-info-from' },
        };
    }

    constructor() {
        super();
        this.currencyPlacement = 'before';
        this.selectedMethod = null;
    }

    getPspTransactionLabel() {
        let cost = '0.00';
        if (this.selectedMethod.paymentModeValues) {
            cost = priceFormatterForceNegative(
                this.selectedMethod.paymentModeValues[0].value,
                this.selectedMethod.paymentModeValues[0].currencyIso,
                false,
                this.currencyPlacement,
            );
        }

        if (this.selectedMethod.paymentModeValues[0].value > 0) {
            cost = `+ ${cost}`;
        } else if (this.selectedMethod.paymentModeValues[0].value < 0) {
            cost = `- ${cost}`;
        }
        return `${cost}`;
    }

    render() {
        return Object.keys(this.selectedMethod).length > 0 &&
            this.selectedMethod.paymentModeValues[0].value !== 0
            ? html`
                  <div class="payment-information">
                      <div>${this.selectedMethod.name}</div>
                      <div class="payment-information__value">
                          ${this.getPspTransactionLabel()}
                      </div>
                  </div>
              `
            : html``;
    }
}

export const mapStateToProps = (state, ctx) => {
    const selectorToUse = ctx.getInfoFrom === 'order' ? orderSelectors : paymentSelectors;
    return {
        selectedMethod: selectorToUse.getSelectedMethod(state),
    };
};

export default () =>
    customElements.define(
        'e2-payment-price-information',
        connect(mapStateToProps, null)(PaymentPriceInformation),
    );
